<template>
  <footer>
    <span>
      🦋 蝴蝶影视平台 &nbsp; / &nbsp; BUTTERFLY PICTURES<br />
      <span>{{ t("footer1") }}</span>
    </span>
    <span>
      <span>{{ t("footer2") }}</span><br />
      <span>{{ t("footer3") }}</span>
    </span>
  </footer>
</template>

<script>
export default {
  name: "FilmFooter",
  props: {
    t: { type: Function, required: true },
  },
};
</script>
